import styled from 'styled-components';

export const RightSectionStyled = styled.div`
  padding: 0 2rem 5rem;
  width: 90%;
  margin: 0 auto;
  max-width: 109.6rem;

  @media (width < 1240px) {
    width: 95%;
  }

  @media (width < 1150px) {
    width: 90%;
  }
`;
